import Dialog from '@pelckmans/elementis/components/dialog';
import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import { ComponentProps, useContext } from 'react';
import ModalContext from '../../../../../contexts/ModalContext';
import { useTranslation } from 'react-i18next';
import parseYoutubeURL from '../../../../../utils/parseYoutubeURL';

interface Props {
  id: string;
  url: string;
  name: string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
}

export default function EmbeddableMediaModal({ id, url, name, headerProps }: Props) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  function handleClose() {
    closeModal(id);
  }

  const parsedYoutubeURL = parseYoutubeURL(url);

  const size: ComponentProps<typeof Dialog>['size'] = 'full';

  return (
    <Dialog
      id={id}
      size={size}
      modal
      onClose={handleClose}
      aria-label={t('PAGES.TOC_LEVEL.MODALS.EMBEDDABLE_MEDIA.A11Y_LABEL')}
      className="fullwidth-embeddable-media embeddable-media "
    >
      <MaterialDialogHeader
        title={headerProps.title}
        onClose={handleClose}
        tags={headerProps.tags}
        titleTooltip={headerProps.titleTooltip}
        showCloseLabelAsText={size === 'full'}
      />
      <Dialog.Body>
        {parsedYoutubeURL ? (
          <div className="youtube-embeddable-media">
            <iframe
              role="presentation"
              title={name}
              src={url}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        ) : (
          <iframe
            role="presentation"
            title={name}
            src={url}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}
      </Dialog.Body>
    </Dialog>
  );
}
